import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { AppTheme } from '../styles/AppTheme';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { Link } from 'react-router-dom';
import { Controller } from '../common/Controller';
import { AppConfig } from '../AppConfig';
import { CommonTheme } from '../styles/Styles';
import { ContactUsFooter } from '../components/ContactUsFooter';
import { ContactComponent } from '../components/ContactComponent';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export class PublicHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
      anchorEl: null,
      modalVisible: false
    }
  }

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  }

  onChange = (e) => {
    this.setState({ searchValue: e.target.value })
  }

  _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.props.history.push({
        pathname: '/search',
        search: '?q=' + this.state.searchValue,
      })
    }
  }

  isAdminPage = () => {
    if (!this.props.history ||
      !this.props.history.location ||
      !this.props.history.location.pathname) {
      return false
    }

    if (this.props.history.location.pathname.startsWith('/admin')) {
      return true
    }

    return false
  }

  handleModal = () => {
    this.setState({
      modalVisible: !this.state.modalVisible,
    })
  }

  render() {
    const appUser = Controller.get().userMgr().getAppUser()
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div>
        <AppBar
          className={css(Styles.appbar)}
          color='primary'
          position='fixed'
          elevation={2}>
          <Toolbar className={css(Styles.toolbarOuterContainer)}>
            <Accordion classes={{root: css(Styles.collapseContainer)}}>

              <div className={css(Styles.toolbar)}>
                <Link
                  className={css(Styles.logoContainer)}
                  to={'/'}
                >
                  <img
                    src={require('../assets/images/logo.svg')}
                    alt='Logo'
                    className={css(Styles.logoImage)} />
                </Link>

                <div className={css(Styles.searchOuterContainer)}>
                  <div className={css(Styles.searchContainer)}>
                    {!this.isAdminPage() &&
                  <div className={css(Styles.search)}>
                    <div className={css(Styles.searchIcon)}>
                      <SearchIcon />
                    </div>
                    <InputBase
                      placeholder={window.innerWidth > 767 ? 'Search medical devices, instruments' : 'Search'}
                      onKeyDown={this._handleKeyDown}
                      classes={{
                        root: css(Styles.inputRoot),
                        input: css(Styles.inputInput),
                      }}
                      onChange={(value) => this.onChange(value)}
                      inputProps={{ 'aria-label': 'search' }}
                    />
                  </div>
                    }

                    {!this.isAdminPage() &&
                  <Link
                    to={'/search?q=' + this.state.searchValue}
                    className={css(Styles.goTile)}>
                    <p>Go</p>
                  </Link>
                    }
                  </div>

                  {!this.isAdminPage() &&
                  <div className={css(Styles.requestButtonContainer)}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon color='secondary'/>}
                      className={css(Styles.accordionSummary)}
                      classes={{
                        content: css(Styles.accordionSummaryContent)
                      }}>
                      <div>
                        <p className={css(Styles.requestStyle)}>REQUEST FOR QUOTE</p>
                      </div>
                    </AccordionSummary>
                  </div>
                  }
                </div>

                {this.state.modalVisible &&
              <ContactComponent
                modalVisible={this.state.modalVisible}
                handleModal={this.handleModal}
                contact={true}
              />
                }

                {this.props.currentUser &&
              <div>
                <IconButton
                  aria-owns={open ? 'menu-appbar' : null}
                  aria-haspopup='true'
                  onClick={this.handleMenu}
                  color='primary'
                >
                  <i className='material-icons' style={{ fontSize: 42 }}>account_circle</i>
                </IconButton>
                <Menu
                  id='menu-appbar'
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={open}
                  onClose={this.handleClose}
                >
                  <MenuItem disabled>Version {AppConfig.VERSION}</MenuItem>
                  {appUser &&
                    <MenuItem disabled>{appUser.email || appUser.phone}</MenuItem>
                  }
                  <MenuItem onClick={this.props.onDashboardClick}>Dashboard</MenuItem>
                  <MenuItem onClick={this.props.onLogoutClick}>Logout</MenuItem>
                </Menu>
              </div>
                }
              </div>
              <AccordionDetails className={css(Styles.accordionDetails)}>
                <ContactUsFooter
                  cat={'HEADER'}
                  handleModal={this.handleModal}/>
              </AccordionDetails>
            </Accordion>

          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  appbar: {
    backgroundColor: AppTheme.secondaryBg,
    // zIndex: 100000,
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  toolbarOuterContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: CommonTheme.webViewPort,
    '@media(max-width: 1024px)': {
      width: CommonTheme.mobViewPort,
    },
  },
  toolbar: {
    minHeight: AppTheme.toolbarHeight,
    alignSelf: 'center',
    display: 'flex',
    '@media(max-width: 767px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '30%',
    ':hover': {
      cursor: 'pointer'
    },
    '@media(max-width: 767px)': {
      width: 'auto',
      marginTop: 10,
      justifyContent: 'center',
    },
  },
  logoImage: {
    maxWidth: 200,
    maxHeight: '100%'
  },
  searchOuterContainer: {
    width: '70%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '@media(max-width: 767px)': {
      display: 'flex',
      width: '100%',
      marginTop: 15,
      marginBottom: 15,
      justifyContent: 'center',
      flexDirection: 'column'
    },
  },
  searchContainer: {
    display: 'flex',
    width: '60%',
    height: 40,
    '@media(max-width: 767px)': {
      width: '100%',
    }
  },
  search: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '20px 0px 0px 20px',
    backgroundColor: '#F4F4F4',
    /*':hover': {
      backgroundColor: 'lightgrey',
    },*/
    width: '100%',
  },
  searchIcon: {
    height: '100%',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'grey',
    marginLeft: 10
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    padding: 10,
    width: '100%',
    color: 'black',
  },
  goTile: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 50,
    backgroundColor: AppTheme.primaryColor,
    color: 'white',
    borderRadius: '0px 20px 20px 0px',
    cursor: 'pointer'
  },

  requestButtonContainer: {
    display: 'flex',
    alignSelf: 'center',
    marginLeft: 10,
    '@media(max-width: 767px)': {
      marginLeft: 0,
      marginTop: 10
    }
  },
  requestStyle: {
    margin: 0,
    fontSize: 13,
    '@media(max-width: 768px)': {
      fontSize: 12
    }
  },
  collapseContainer: {
    boxShadow: 'unset',
  },
  accordionSummary: {
    margin: 0,
    color: AppTheme.secondaryColor,
    fontSize: 14,
    borderRadius: 20,
    backgroundColor: AppTheme.primaryColor,
    minHeight: 'unset',
    maxHeight: 40,
    padding: '0px 10px 0px 15px'
  },
  accordionSummaryContent: {
    margin: 0,
    marginRight: -10
  },
  expandIcon: {
    padding: 5,
    paddingLeft: 5
  },
  accordionDetails: {
    paddingLeft: 0,
    paddingRight: 0
  }
})


// WEBPACK FOOTER //
// ./src/components/PublicHeader.js